import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBaseSort = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.66699 10L8.00033 13.3333L11.3337 10M4.66699 6.00002L8.00033 2.66669L11.3337 6.00002",
		stroke: "currentColor",
		strokeOpacity: .6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconBaseSort;
